const deferred = [];
__webpack_require__.O = (result, chunkIds, fn, priority) => {
	if(chunkIds) {
		priority ||= 0;
		for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
		deferred[i] = [chunkIds, fn, priority];
		return;
	}
	let notFulfilled = Infinity;
	for (var i = 0; i < deferred.length; i++) {
		let [chunkIds, fn, priority] = deferred[i];
		let fulfilled = true;
		for (var j = 0; j < chunkIds.length; j++) {
			if (((priority & 1) === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
				chunkIds.splice(j--, 1);
			} else {
				fulfilled = false;
				if(priority < notFulfilled) notFulfilled = priority;
			}
		}
		if(fulfilled) {
			deferred.splice(i--, 1)
			const r = fn();
			if (r !== undefined) result = r;
		}
	}
	return result;
};